<template>
  <div>
    <div class="action-loader" v-if="cloader.display">
      <loader></loader>
      <span>{{ cloader.label }}</span>
    </div>
  </div>
</template>

<script>
import Loader from '../ui/loader.vue';
export default {
  components: { Loader },
  computed: {
    cloader() {
      return this.$store.state.ui.cloader;
    },
  },
};
</script>
<style lang="scss">
.action-loader {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background: #4f1b896b;
  height: 100vh;
  z-index: 9;
  display: flex;
  align-items: center;
  font-weight: 600;
  justify-content: center;
  font-size: 2em;
  color: white;
  flex-direction: column;
}
.loader .svg-loader {
  background: none !important;
}
</style>
